import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

const ReferralRedirect = () => {
  const { slug } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const trackReferral = async () => {
      try {
        const res = await axios.get(`${API}/affiliates/ref/${slug}`);
        // Store referral in cookie (30 days)
        const expires = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toUTCString();
        document.cookie = `ref_affiliate=${res.data.affiliate_id}; expires=${expires}; path=/`;
        document.cookie = `ref_slug=${res.data.slug}; expires=${expires}; path=/`;
      } catch (err) {
        // Invalid referral slug - redirect silently
      }
      navigate('/', { replace: true });
    };
    trackReferral();
  }, [slug, navigate]);

  return (
    <div className="min-h-screen bg-[#0A2647] flex items-center justify-center">
      <div className="animate-spin w-8 h-8 border-4 border-[#C5A059] border-t-transparent rounded-full" />
    </div>
  );
};

export default ReferralRedirect;
